import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const StyledSampleCompositionCointainer = styled(Box, {
  display: 'flex',
  marginRight: '$7',
  marginTop: '$4',
});

export const StyledCompositionColumnContainer = styled(Box, {
  display: 'flex',
  flex: '1 0 230px',
  justifyContent: 'space-between',
});

export const StyledColumn = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
});

export const StyledRow = styled(Box, {
  alignItems: 'center',
  display: 'flex',
});

export const StyledContentSeparator = styled(Box, {
  borderRight: 'solid $borderWidths$2 $seafoam500',
  height: '$9',
  margin: '0 $4',
});

export const StyledTotalDetails = styled(Box, {
  color: '$darkBlue400',
  fontSize: '$normal',
  fontWeight: '$regular',
  lineHeight: '$6',
});

export const StyledPercentage = styled(Box, {
  color: '$darkBlue500',
  fontSize: '$xl',
  fontWeight: '$regular',
  marginTop: '$1',
  textAlign: 'initial',
  width: '$8',
});

export const StyledContentIcon = styled(Box, {
  alignItems: 'center',
  border: '$borderWidths$1 solid $darkGray800',
  borderRadius: '$radii$8',
  display: 'flex',
  justifyContent: 'center',
  marginRight: '$4',
  minHeight: '60px',
  minWidth: '60px',
  padding: '$1',

  svg: {
    height: '42px',
    width: '$studyInsights$studyInsightsXl',
  },
});

export const StyledTitle = styled(Box, {
  color: '$darkBlue100',
  fontSize: '$md',
  fontStyle: '$regular',
  marginBottom: '$2',
  paddingBottom: '$2',
  textAlign: 'left',
  textDecoration: 'none',
});

export const StyledContent = styled(Box, {
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  padding: '2px 0',
});

export const StyledTopContent = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  marginRight: '$10',
});

export const StyledBottomContent = styled(Box, {
  color: '$darkBlue400',
  fontSize: '$sm',
  maxWidth: '150px',
  textAlign: 'left',
});
